<div class="aad-panel">
  <header class="aad-header">
    <div class="aad-header__text">
      <p class="aad-header__eyebrow">Today's Attendance</p>
      <h2 class="aad-header__title">Attendance Overview</h2>
      <p class="aad-header__subtitle">Unattended classes and daily absence highlights</p>
    </div>
    <button type="button" class="aad-close-btn" (click)="dialogRef.close()" aria-label="Close">
      <i class="material-icons">close</i>
    </button>
  </header>

  <div class="aad-loader" *ngIf="loading">
    <mat-spinner diameter="40"></mat-spinner>
    <p>Loading attendance data…</p>
  </div>

  <ng-container *ngIf="!loading">
    <div class="aad-kpis">
      <article class="aad-kpi aad-kpi--warning">
        <div class="aad-kpi__icon"><i class="material-icons">schedule</i></div>
        <div>
          <p class="aad-kpi__label">Shift 1 Pending</p>
          <h3 class="aad-kpi__value">{{ shiftOneCount }}</h3>
        </div>
      </article>
      <article class="aad-kpi aad-kpi--danger">
        <div class="aad-kpi__icon"><i class="material-icons">person_off</i></div>
        <div>
          <p class="aad-kpi__label">Absent Classes</p>
          <h3 class="aad-kpi__value">{{ absentClassCount }}</h3>
        </div>
      </article>
      <article class="aad-kpi aad-kpi--info">
        <div class="aad-kpi__icon"><i class="material-icons">schedule</i></div>
        <div>
          <p class="aad-kpi__label">Shift 2 Pending</p>
          <h3 class="aad-kpi__value">{{ shiftTwoCount }}</h3>
        </div>
      </article>
    </div>

    <div class="aad-grid">
      <!-- Shift 1 Unattended -->
      <section class="aad-card">
        <div class="aad-card__head">
          <div class="aad-card__head-main">
            <span class="aad-card__icon aad-card__icon--warning"><i class="material-icons">event_busy</i></span>
            <div>
              <h3 class="aad-card__title">Shift 1 — Unattended</h3>
              <p class="aad-card__sub">Classes without attendance today</p>
            </div>
          </div>
          <span class="aad-badge aad-badge--warning">{{ shiftOneCount }}</span>
        </div>

        <div class="aad-list" *ngIf="stdSection?.length; else emptyShiftOne">
          <article class="aad-item" *ngFor="let section of stdSection">
            <div class="aad-item__main">
              <span class="aad-item__dot aad-item__dot--warning"></span>
              <span class="aad-item__label">{{ section.class_section }}</span>
            </div>
            <a
              class="aad-action"
              [routerLink]="['/attendance/add-new']"
              (click)="dialogRef.close()">
              <i class="material-icons">edit_calendar</i>
              <span>Take</span>
            </a>
          </article>
        </div>
        <ng-template #emptyShiftOne>
          <div class="aad-empty">
            <i class="material-icons">check_circle</i>
            <p>All shift 1 classes are attended.</p>
          </div>
        </ng-template>
      </section>

      <!-- Daily Most Absent -->
      <section class="aad-card aad-card--accent">
        <div class="aad-card__head">
          <div class="aad-card__head-main">
            <span class="aad-card__icon aad-card__icon--danger"><i class="material-icons">trending_down</i></span>
            <div>
              <h3 class="aad-card__title">Most Absent Classes</h3>
              <p class="aad-card__sub">Highest absent counts today (shift 1)</p>
            </div>
          </div>
          <span class="aad-badge aad-badge--danger">{{ totalAbsentStudents }}</span>
        </div>

        <div class="aad-list" *ngIf="absentCounts?.length; else emptyAbsent">
          <article class="aad-item aad-item--ranked" *ngFor="let absent of absentCounts; let i = index">
            <div class="aad-item__main">
              <span class="aad-rank" [class.aad-rank--top]="i < 3">{{ i + 1 }}</span>
              <div class="aad-item__text">
                <span class="aad-item__label">{{ absent.class_name }} — {{ absent.section_name }}</span>
              </div>
            </div>
            <span class="aad-count">{{ absent.absent_students_count }}</span>
          </article>
        </div>
        <ng-template #emptyAbsent>
          <div class="aad-empty">
            <i class="material-icons">sentiment_satisfied</i>
            <p>No absences recorded for today.</p>
          </div>
        </ng-template>
      </section>

      <!-- Shift 2 Unattended -->
      <section class="aad-card">
        <div class="aad-card__head">
          <div class="aad-card__head-main">
            <span class="aad-card__icon aad-card__icon--info"><i class="material-icons">event_busy</i></span>
            <div>
              <h3 class="aad-card__title">Shift 2 — Unattended</h3>
              <p class="aad-card__sub">Classes without attendance today</p>
            </div>
          </div>
          <span class="aad-badge aad-badge--info">{{ shiftTwoCount }}</span>
        </div>

        <div class="aad-list" *ngIf="shiftTwo?.length; else emptyShiftTwo">
          <article class="aad-item" *ngFor="let section of shiftTwo">
            <div class="aad-item__main">
              <span class="aad-item__dot aad-item__dot--info"></span>
              <span class="aad-item__label">{{ section.class_section }}</span>
            </div>
            <a
              class="aad-action"
              [routerLink]="['/attendance/add-new']"
              (click)="dialogRef.close()">
              <i class="material-icons">edit_calendar</i>
              <span>Take</span>
            </a>
          </article>
        </div>
        <ng-template #emptyShiftTwo>
          <div class="aad-empty">
            <i class="material-icons">check_circle</i>
            <p>All shift 2 classes are attended.</p>
          </div>
        </ng-template>
      </section>
    </div>

    <footer class="aad-footer">
      <a class="aad-footer__link" routerLink="/attendance/summary" (click)="dialogRef.close()">
        <i class="material-icons">summarize</i>
        View full attendance summary
      </a>
    </footer>
  </ng-container>
</div>
